<template>
  <div class="main-content" :class="centerLayoutClass">
    <SettingsOpenButton v-if="!isWidget" />
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

import SettingsOpenButton from "@/components/ui/buttons/SettingsOpenButton.vue";

const store = useGlobalStore();
const orderStore = useOrderFormStore();
const route = useRoute();
const isWidget = computed(() => route?.name && route.name.includes("widget"));
const centerLayoutClass = computed(() => {
  if (store.getIsGreyLabel) {
    return "grey-label"
  }
  if (orderStore.isNFTMode) {
    return "nft-layout"
  }
  return "";
});
</script>

<style lang="scss">
.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  overflow: scroll;
  flex: 1;

  > .form {
    padding: 0 2rem;

    @include breakpoint($min-m) {
      padding: var(--padding-1);
    }
  }

  @include breakpoint($min-m) {
    background: var(--input-background);
    > div:not(.footer):not(.powered-footer) {
      margin: 2rem;
    }
  }

  & .settings-btn {
    display: none;
    padding: var(--padding-1);

    @include breakpoint($min-m) {
      display: block;
    }
  }
}

.main-content.grey-label {
  background: none;

  > .form {
    padding-top: 0;

    @include breakpoint($min-m) {
      padding-bottom: 1em;
    }
  }

  @include breakpoint($min-m) {
    > div:not(.footer):not(.powered-footer) {
      margin-bottom: 0;
    }
  }

  & .settings-btn {
    display: none;
  }
}

.main-content.nft-layout {
  background: none;

  > .form {
    padding-top: 0;

    @include breakpoint($min-m) {
      padding-bottom: 1em;
    }
  }

  @include breakpoint($min-m) {
    > div:not(.footer):not(.powered-footer) {
      margin-top: 1rem;
      margin-bottom: 0;
    }
  }

  & .settings-btn {
    display: none;
  }
}
</style>
